<template>
    <div>
        <main-navigation-button
            :group="currentGroup"
            :isOpen="isNavMenuOpen"
            @click.native="openNavMenu"
            class="cz2__main-navigation-button"
            :shouldReclaimFocus="shouldReclaimFocus"
            :light="light"
        />
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__main-navigation {
            margin-top: -10px;

            .cz2__main-navigation-menu-backdrop {
                position: fixed;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                z-index: 99999;

                width: var(--vw100, 100vw);
                height: var(--vw100, 100vh);
                background-color: rgba(255, 255, 255, 0.6);
                backdrop-filter: blur(20px);
            }

            .cz2__main-navigation-menu {
                padding: 10px 16px;

                width: 100%;
                height: 100%;
            }

            .cz2__main-navigation-menu-header {
                margin-bottom: 16px;

                width: 100%;

                display: flex;
                justify-content: space-between;
            }

            .cz2__main-navigation-menu-logo {
                width: 83px;
                height: 77px;
            }

            .cz2__main-navigation-menu-close {
                margin-top: 8px;

                width: 32px;
                height: 32px;
                background: transparent url(../assets/icons/close-white.svg) no-repeat center/contain;
            }

            @include respond-above(lg) {
                margin-left: -24px;

                .cz2__main-navigation-menu-logo {
                    width: 130px;
                    height: 119px;
                }
            }

            @include respond-above(xl) {
                .cz2__main-navigation-menu-close {
                    width: 56px;
                    height: 56px;
                }

                .cz2__main-navigation-menu-logo {
                    width: 212px;
                    height: 195px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__main-navigation {
            margin-top: -82px;
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2.cz2__is-sb.cz2__is-kiosk {
        .cz2__main-navigation {
            margin-top: 0px;
        }
    }
</style>

<script>
    import MainNavigationButton from './MainNavigationButton.vue';

    export default {
        components: {
            MainNavigationButton,
        },

        props: {
            light: Boolean,
        },

        data() {
            return {
                shouldReclaimFocus: false,
            };
        },

        computed: {
            currentGroup() {
                return this.$store.state.customizer.currentGroup;
            },

            isNavMenuOpen() {
                return this.$store.state.customizer.isNavMenuOpen;
            },
        },

        watch: {
            isNavMenuOpen(isOpen) {
                if (!isOpen && this.shouldReclaimFocus) {
                    setTimeout(() => {
                        const mainNavigationButton = document.getElementById('main-navigation-button');
                        if (mainNavigationButton && mainNavigationButton.getAttribute('data-reclaim-focus') === 'true') {
                            mainNavigationButton.focus();
                            mainNavigationButton.removeAttribute('data-reclaim-focus');
                            this.shouldReclaimFocus = false;
                        }
                    }, 100);
                }

                if (isOpen) {
                    this.shouldReclaimFocus = true;
                }
            },
        },

        methods: {
            openNavMenu() {
                this.$store.dispatch('setIsNavMenuOpen', true);
            },
        },
    };
</script>
